import React, { useState } from 'react';
import './HoverReveal.scss';

function HoverReveal(props) {
    const [isHovering, setIsHovering] = useState(false);
    const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });

    function handleMouseEnter() {
        setIsHovering(true);
    }

    function handleMouseLeave() {
        setIsHovering(false);
    }

    function handleMouseMove(event) {
        setHoverPosition({ x: event.clientX, y: event.clientY });
    }

    const revealStyle = {
        opacity: isHovering ? 1 : 0,
        transform: isHovering
            ? 'translate(-100%, -50%) rotate(5deg)'
            : 'translate(-50%, -50%) rotate(-5deg)',
        left: hoverPosition.x + 'px'
    };

    const imageStyle = {
        transform: isHovering ? 'scale(1, 1)' : 'scale(0.8, 0.8)'
    };

    return (
        <a
            href={props.href}
            className="project"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
            target="_blank"
        >
            <div className="project__text">
                <h2 className="project__title">{props.title}</h2>
                <p className="project__info">{props.info}</p>
            </div>
            <div className={`hover-reveal`} style={revealStyle}>
                <img className="hidden-img" src={props.imageSrc} alt="" style={imageStyle} />
            </div>
            <div className="project_number">{props.projectNumber}</div>
        </a>
    );
}

export default HoverReveal;